import React from "react";
import ReactTooltip from "react-tooltip";
import { Col, Row, Tab, Nav, Dropdown } from "react-bootstrap";
import storage from "../../../../Storage";
import coins from "../../../coins";
import socket from "../../../../Socket";
import { __, isMobile, encode, decode, getElement, wait, forceSatoshiFormat, sendNotfication, Event } from "../../../../Helper";
import DepositArchive from "./DepositArchive";
import C from "../../../../Constant";

class Deposit extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            token: storage.getKey('token'),
            msisdn: storage.getKey('email'),
            currentCoin: 'kshs',
            loading: true,
            response: '',
            credits: {},
            list: [],
            content: [],
            wallet: 'Please Wait...',
            deposit: true,
            submitted: false,
            processing: false,
            slide: false,
            height: 573,
            margin: 'mt-1',
            amount: ''
        };
    }


    componentDidMount() {
        this._isMounted = true;

        socket.emit(C.CREDIT, encode({ token: this.state.token, coin: this.state.currentCoin }));
        // socket.on(C.GET_ADDRESS, data => this.getAddress(decode(data)));
        socket.on(C.CREDIT, data => this.getCreditAndCoins(decode(data)));
        socket.on(C.STK_DEPOSIT, data => this.loadCredit(decode(data)));

        wait(400).then(() => {
            this.loadAddress(true, this.state.currentCoin);
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.state.intervalId);
    }

    myTimer = () => {
        var now = new Date().toLocaleTimeString();
        console.log('Interval triggered ' + now);
        socket.emit(C.CREDIT, encode({ token: this.state.token, coin: this.state.currentCoin }));
    }

    getCreditAndCoins = (data) => {
        // console.log(data.credit.kshs);

        if (this._isMounted) {
            let { credit } = data;
            this.setState({ credits: credit, loading: false });
            this.setUpCoins();
        }
    };

    loadCredit = (data) => {
        if (this._isMounted) {
            if (data.status.responseCode === 0) {
                const intervalId = setInterval(this.myTimer, 5000);
                this.setState({ intervalId });

                this.setState({ submitted: true, processing: false, response: data.status.responseDescription });
            }
            else {
                this.setState({ submitted: true, processing: false, response: data.status });
            }
        }
    };

    getFee = (coin) => {
        coin = __.upperCase(coin);

        let min;
        coins.forEach((item, key) => {
            if (item.preffix === coin)
                min = item.min;
        })

        return min;
    }

    setUpCoins = () => {
        if (isMobile()) {
            this.setState({ height: 685, margin: 'mt-1' });
        }

        coins.forEach((item, key) => {
            let credit = forceSatoshiFormat(this.state.credits[__.lowerCase(item.preffix)]);
            let list = <Dropdown.Item as={'button'} className={"animated fadeIn"} onClick={(e) => this.loadAddress(item.active, item.preffix)}>
                <span><img src={"/assets/images/" + item.image} className={"img-fluid mini-coin mr-1"} alt="Coin" /> {item.preffix}</span>
            </Dropdown.Item>;
            this.setState(state => ({ list: [list, ...state.list] }));
        });
    };

    showArchive = e => {
        this.setState({ slide: !this.state.slide });
        wait(500).then(() => {
            this.setState({ deposit: !this.state.deposit });
        })
        wait(500).then(() => {
            this.loadAddress(true, this.state.currentCoin);
        })
    };

    copyAddress(id) {
        var address = getElement('#' + id);
        address.select();
        address.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy");
        sendNotfication('Copied !', 'success', 'top-right')
    }

    loadAddress(active, coin) {
        if (this._isMounted) {
            this.setState({ currentCoin: coin, depositAddress: "Please Wait ..." });
            if (active) socket.emit(C.GET_ADDRESS, encode({ coin: coin, token: storage.getKey('token') }));
            else {
                this.setState({ depositAddress: `${coin} not Supported yet` });
            }
        }
    }

    getAddress(data) {
        if (!data) return;
        let { address } = data;
        this.setState({ wallet: address, qr: 'https://chart.googleapis.com/chart?chs=500x500&cht=qr&chl=' + this.state.currentCoin + ':' + address });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        const { amount, msisdn } = this.state;

        console.log(amount);

        if (!(amount)) {
            this.setState({ disabled: false, status: false });
            return;
        }
        //Execute Recaptcha Token
        // const token = await this.recaptchaRef.current.executeAsync();

        this.setState({ processing: true, submitted: false });

        wait(1000).then(() => {
            socket.emit(C.STK_DEPOSIT, encode({
                token: this.state.token,
                amount: amount,
                msisdn: msisdn
            }));
        })
    }

    render() {
        let { height, margin, loading, digi } = this.state;
        let style;
        let size = 'w-25';

        if (isMobile()) {
            style = "col-2";
            size = 'w-50'
        }

        return (
            <>
                {
                    this.state.deposit ?
                        <div className={this.state.slide ? 'animated slideOutLeft ' : ' ffont-14'}>
                            {this.state.loading ?
                                <div className="ycenter text-center">
                                    <div class="spinner-border text-info" role="status" />
                                </div>
                                :
                                <>
                                    <div className="balance-card-gradient">
                                        <div className="balance-label">Total Balance</div>
                                        <div className="balance-amount">
                                            {forceSatoshiFormat(this.state.credits[__.lowerCase(this.state.currentCoin)])}
                                            <span className="ml-2" style={{ fontSize: '1rem', opacity: 0.6 }}>KES</span>
                                        </div>
                                    </div>


                                    <form className="auth-form px-3 mb-4" onSubmit={(e) => { this.handleSubmit(e) }}>
                                        <div className="wallet-input-group px-0">
                                            <label className="wallet-input-label">Enter Amount to Deposit</label>
                                            <input
                                                type="text"
                                                autoComplete="off"
                                                id={this.state.currentCoin}
                                                onChange={e => this.setState({ amount: e.target.value })}
                                                className='form-control wallet-input-field'
                                                placeholder="0.00"
                                            />

                                            {this.state.submitted &&
                                                <div className="alert bg-success text-white mt-3 py-2 px-3" style={{ borderRadius: '10px' }}>
                                                    {this.state.response}
                                                </div>
                                            }
                                        </div>


                                        <div className="text-center px-3">
                                            <button
                                                className="btn wallet-submit-btn btn-block text-white"
                                                disabled={this.state.disabled || this.state.processing}
                                            >
                                                {this.state.processing ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm mr-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                        Processing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="mdi mdi-cash-multiple mr-2 font-18" /> Lipa Na Mpesa Online
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                    </form>

                                    {/* <div className="text-center mb-3">
                                                <img id={'qr'} src={this.state.qr} className={"img-thumbnail qri " + size} alt=""/>
                                            </div> */}
                                    <div className="wallet-footer-info">
                                        <div onClick={this.showArchive} className='cursor-pointer text-decoration-underline'>View Transaction History</div>
                                        <div className="mt-2 opacity-50">Instant processing • Secure transaction</div>
                                    </div>

                                </>
                            }
                        </div>
                        :
                        <>
                            <div className={this.state.slide == false ? 'animated slideOutLeft' : ''}>
                                <DepositArchive clicked={this.showArchive} />
                            </div>
                        </>
                }
            </>
        );
    }
}

export default Deposit;